import { useSelector } from "react-redux";
import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import ProductListCard from "./ProductListCard";
import { loadProductList } from "../../redux/actions";
import Preloader from "./Preloader";
import { AnalyticsDataStore } from "../../hooks/analytics-data";

const ProductListPage = () => {
    const { product_category } = useParams();
    const [grid, setGrid] = useState(false);
    const [active, setActive] = useState(false);
    const [products, setProducts] = useState([]);
    const [sidebar, setSidebar] = useState();
    const [childcategories, setchildCategories] = useState();
    const [brands, setchildBrands] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const region = useSelector((state) => state.region.region); // Get the current region from the state
    const [totalItems, setTotalItems] = useState(0); //total no of item
    const [currentPage, setCurrentPage] = useState(1); //current page
    const [totalPages, setTotalPages] = useState(0); //total no of page
    const [startItem, setStartItem] = useState(0); // starting number
    const [endItem, setEndItem] = useState(0); // ending number
    const [sorting, setSorting] = useState("price_asc"); //sorting order
    const [productid, setProductid] = useState(); // ending number
    const [toggle, setToggle] = useState(); // ending number

    useEffect(() => {
        setCurrentPage(1);
    }, [product_category]);


    const fetchProducts = useCallback(async (page = currentPage) => {
        try {
            setProducts([]);
            setLoading(true);

            const response = await loadProductList(
                product_category,
                region,
                page,
                sorting,
                productid,
                toggle
            );
            let products = [];

            const newSlug = response?.page?.data?.category?.slug?.toUpperCase();
            const existingSlug = sidebar?.page?.data?.category?.slug?.toUpperCase();

            if (response?.page?.data) {
                if (!sidebar || newSlug !== existingSlug) {
                    setSidebar(response);
                    setchildCategories(response?.page?.data?.child_categories);
                    setchildBrands(response?.page?.data?.filters?.brands);
                    // setToggleStates({
                    //     InStock: 0,
                    //     IsNew: 0,
                    //     IsSustainable: 0,
                    //     IsBestseller: 0,
                    //     IsPremium: 0,
                    //     OnSale: 0,
                    // });
                }

                products = response?.page?.data?.products;
            }

            let totalItem = response?.page?.data?.total;
            let itemsPerPage = Math.max(products?.length || 0, 9);
            let totalPage = Math.ceil(totalItem / itemsPerPage);

            setProducts(products);
            setTotalItems(totalItem);
            setTotalPages(totalPage);

            const analyticsStore = new AnalyticsDataStore();
            analyticsStore.rootStore = {};
            analyticsStore.view_item(products);   

            let startItems = 0;
            if (totalItem !== 0) {
                startItems = (currentPage - 1) * itemsPerPage + 1;
            }
            const endItems = Math.min(currentPage * itemsPerPage, totalItem);

            setStartItem(startItems);
            setEndItem(endItems);
            setLoading(false);
        } catch (error) {
            setError(error?.message);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }, [product_category, region, currentPage, sorting, productid, toggle]);
    
    // Fetch products data from API
    useEffect(() => {
        const timeout = setTimeout(() => {
            fetchProducts(currentPage);
        }, 100); // small delay to allow state to settle
    
        return () => clearTimeout(timeout); // cleanup on unmount or next run
    }, [currentPage, fetchProducts]);

    const handlePageChange = async (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            //await fetchProducts();
        }
    };

    const prevCategoryRef = useRef(null);

    useEffect(() => {
        if (product_category && prevCategoryRef.current) {
            if (product_category !== prevCategoryRef.current) {
                console.log(
                    "Category changed from",
                    prevCategoryRef.current,
                    "to",
                    product_category
                );
            }
        }

        prevCategoryRef.current = product_category;
    }, [product_category]);

    const productList = useMemo(() => {
        return products.map((product) => (
            <ProductListCard productId={product.id} product={product} />
        ));
    }, [products]);

    const sidebarController = () => {
        setActive(!active);
    };

    const [openFilters, setOpenFilters] = useState({});
    const [selectedBrandIds, setSelectedBrandIds] = useState([]);
    const [selectedFilterIds, setSelectedFilterIds] = useState([]);

    const toggleCheckboxes = (filterKey) => {
        setOpenFilters((prev) => ({
            ...prev,
            [filterKey]: !prev[filterKey], // Toggle dropdown without affecting checkboxes
        }));
    };

    const handleBrandCheckboxChange = (valueId) => {
        setSelectedBrandIds(
        (prev) =>
            prev.includes(valueId)
            ? prev.filter((id) => id !== valueId) // Remove if unchecked
            : [...prev, valueId] // Add if checked
        );
    };

    // ✅ Function to handle filter checkbox change
    const handleFilterCheckboxChange = (valueId) => {
        setSelectedFilterIds(
        (prev) =>
            prev.includes(valueId)
            ? prev.filter((id) => id !== valueId) // Remove if unchecked
            : [...prev, valueId] // Add if checked
        );
    };

    // ✅ Preserve checked state
    const isBrandChecked = (valueId) => selectedBrandIds.includes(valueId);
    const isFilterChecked = (valueId) => selectedFilterIds.includes(valueId);

    // ✅ Effect to update the URL when state changes
    useEffect(() => {
        let queryParams = [];

        if (selectedBrandIds.length > 0) {
            queryParams.push(`brand_ids=${selectedBrandIds.join(",")}`);
        }
        if (selectedFilterIds.length > 0) {
            queryParams.push(`attribute_value_ids=${selectedFilterIds.join(",")}`);
        }

        const queryString =
        queryParams.length > 0 ? `&${queryParams.join("&")}` : "";
        const newUrl = queryString;
        setProductid(newUrl);
        //navigate(newUrl, { replace: true }); // ✅ Updates the URL without refreshing
    }, [selectedBrandIds, selectedFilterIds]);

    const filter = sidebar?.page?.data?.filters?.available_filter_values || {};
    const filter1 = sidebar?.page?.data?.filters?.template?.filters || [];
    //const sorting_fields = sidebar?.page?.data?.sorting_fields_for_reference;

    const attributeMap = filter1.reduce((acc, item) => {
        acc[item.attribute] = item.name.en; // Use English name
        return acc;
    }, {});

    // Convert object to array with renamed keys
    const updatedFilterArray = Object.entries(filter).map(([key, value]) => {
        return {
            name: attributeMap[key] || key, // Replace key if found in attributeMap
            values: Object.values(value), // Convert inner object to array of values
        };
    });

    // const queryStringKeys = {
    //     InStock: "in_stock",
    //     IsNew: "is_new",
    //     IsSustainable: "is_sustainable",
    //     IsBestseller: "is_bestseller",
    //     IsPremium: "is_premium",
    //     OnSale: "is_discounted",
    // };

    // Initialize toggleStates based on sorting_fields
    // const [toggleStates, setToggleStates] = useState({
    //     InStock: 0,
    //     IsNew: 0,
    //     IsSustainable: 0,
    //     IsBestseller: 0,
    //     IsPremium: 0,
    //     OnSale: 0,
    // });

    // Function to handle toggle switch changes
    // const handleToggle = (key) => {
    //     setToggleStates((prev) => {
    //         const updatedStates = {
    //             ...prev,
    //             [key]: prev[key] === 1 ? 0 : 1, // Toggle between 1 and 0
    //         };

    //         // Generate query string using mapped keys
    //         const queryString = Object.entries(updatedStates)
    //             .map(([stateKey, value]) => `${queryStringKeys[stateKey]}=${value}`)
    //             .join("&");

    //         setToggle(queryString);

    //         return updatedStates;
    //     });
    // };

  return (
    <>
      <div className="breadcrumb mb-0 py-26 bg-main-product-50">
        <div className="container container-lg">
          <div className="breadcrumb-wrapper flex-between flex-wrap gap-16">
            <div className="container container-lg">
              <div className="row">
                <div className="col-lg-8">
                  <h3 className="mb-0 text-white">
                    {sidebar?.page?.data?.category?.slug
                      .charAt(0)
                      .toUpperCase() +
                      sidebar?.page?.data?.category?.slug
                        .slice(1)
                        .toLowerCase()}
                  </h3>
                  <br></br>
                  <p className="mb-0 text-white" style={{ fontSize: "17px" }}>
                    {sidebar?.page?.data?.category?.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="shop py-40">
        <div className={`side-overlay ${active && "show"}`}></div>
        <div className="container container-lg">
          {/* <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-9">
              <div className="toggle-container">
                {Object.entries(toggleStates).map(([key, value]) => (
                  <div
                    key={key}
                    className="d-flex align-items-center me-4 mb-2"
                  >
                    <span className="text-black font-medium me-2">
                      {key.replace(/([A-Z])/g, " $1")}
                    </span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={value === 1}
                        onChange={() => handleToggle(key)}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br></br> */}
          <div className="row">
            {/* Sidebar Start */}
            <div className="col-lg-3">
              <div className={`shop-sidebar ${active && "active"}`}>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
                >
                  <i className="ph ph-x" />
                </button>

                <div className="shop-sidebar__box border border-gray-100 rounded-8 p-18 mb-32">
                  <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                    {sidebar?.page?.data?.category?.slug.replace(
                      /\b\w/g,
                      (char) => char.toUpperCase()
                    )}
                  </h6>
                  <ul className="max-h-540 overflow-y-auto scroll-sm">
                    {childcategories &&
                      childcategories.length > 0 &&
                      childcategories.map((data, index) => (
                        <>
                            <li className="mb-24" id={index}>
                                <Link
                                    to={`/product-list/${data.slug}`}
                                    className="text-gray-900 hover-text-main-600 d-flex justify-content-between align-items-center"
                                >
                                    <b>{data?.name}</b>
                                    <i
                                        className="ph ph-caret-right  "
                                        style={{
                                        color: "0d55a3 ",
                                        fontSize: "x-large",
                                        }}
                                    ></i>
                                </Link>
                            </li>

                            <hr></hr>
                        </>
                      ))}
                  </ul>
                </div>

                <div className={`shop-sidebar ${active && "active"}`}>
                  <button
                    onClick={sidebarController}
                    type="button"
                    className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
                  >
                    <i className="ph ph-x" />
                  </button>

                  {brands && Object.keys(brands).length > 0 && (
                    <div className="shop-sidebar__box border border-gray-100 rounded-8 p-18 mb-32">
                      <ul className="max-h-540 overflow-y-auto scroll-sm">
                        <li className="mb-24">
                          <div className="d-flex justify-content-between align-items-center">
                            <b className="text-black">Brands</b>
                            <i
                              className={`ph ${
                                openFilters["brands"]
                                  ? "ph-caret-up"
                                  : "ph-caret-down"
                              }`}
                              style={{
                                color: "#0d55a3",
                                fontSize: "x-large",
                                cursor: "pointer",
                              }}
                              onClick={() => toggleCheckboxes("brands")}
                            ></i>
                          </div>

                          {openFilters["brands"] && (
                            <div className="mt-4">
                                {Object.values(brands).map((brand) => (
                                    <label
                                        key={brand.value_id}
                                        className="d-flex align-items-center"
                                    >
                                        <input
                                            type="checkbox"
                                            className="me-2"
                                            value={brand.value_id}
                                            checked={isBrandChecked(brand.value_id)} // ✅ Explicitly set checked state
                                            onChange={() =>
                                                handleBrandCheckboxChange(brand.value_id)
                                            }
                                        />
                                        <p className="text-black text-m">
                                            {brand.value}
                                        </p>
                                    </label>
                              ))}
                            </div>
                          )}
                        </li>
                      </ul>
                    </div>
                  )}

                  {updatedFilterArray &&
                    updatedFilterArray.length > 0 &&
                    updatedFilterArray.map((data, index) => (
                      <div
                        key={index}
                        className="shop-sidebar__box border border-gray-100 rounded-8 p-18 mb-32"
                      >
                        <ul className="max-h-540 overflow-y-auto scroll-sm">
                          <li className="mb-24">
                            <div className="d-flex justify-content-between align-items-center">
                              <b className="text-black">{data?.name}</b>
                              <i
                                className={`ph ${
                                  openFilters[data?.name]
                                    ? "ph-caret-up"
                                    : "ph-caret-down"
                                }`}
                                style={{
                                  color: "#0d55a3",
                                  fontSize: "x-large",
                                  cursor: "pointer",
                                }}
                                onClick={() => toggleCheckboxes(data?.name)}
                              ></i>
                            </div>

                            {openFilters[data?.name] && (
                              <div className="mt-4">
                                {data?.values.map((value) => (
                                  <label
                                    key={value.value_id}
                                    className="d-flex align-items-center"
                                  >
                                    <input
                                      type="checkbox"
                                      className="me-2"
                                      value={value.value_id}
                                      checked={isFilterChecked(value.value_id)} // ✅ Explicitly set checked state
                                      onChange={() =>
                                        handleFilterCheckboxChange(
                                          value.value_id
                                        )
                                      }
                                    />
                                    <p className="text-black text-m">
                                      {value.value}
                                    </p>
                                  </label>
                                ))}
                              </div>
                            )}
                          </li>
                        </ul>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {/* Sidebar End */}
            {/* Content Start */}
            <div className="col-lg-9">
              {/* Top Start */}

              <div className="flex-between gap-16 flex-wrap mb-40 ">
                <span className="text-gray-900">
                  Showing {startItem}–{endItem} of {totalItems} result
                </span>
                <div className="position-relative flex-align gap-16 flex-wrap">
                  <div className="list-grid-btns flex-align gap-16">
                    <button
                      onClick={() => setGrid(true)}
                      type="button"
                      className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                        grid === true &&
                        "border-main-600 text-white bg-main-600"
                      }`}
                    >
                      <i className="ph-bold ph-list-dashes" />
                    </button>
                    <button
                      onClick={() => setGrid(false)}
                      type="button"
                      className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                        grid === false &&
                        "border-main-600 text-white bg-main-600"
                      }`}
                    >
                      <i className="ph ph-squares-four" />
                    </button>
                  </div>
                  <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                    <label
                      htmlFor="sorting"
                      className="text-inherit flex-shrink-0"
                    >
                      Sort by:{" "}
                    </label>
                    <select
                      defaultValue={1}
                      className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                      id="sorting"
                      value={sorting}
                      onChange={(e) => setSorting(e.target.value)} // Handle change
                    >
                      <option value="price_asc">Price Asc</option>
                      <option value="price_desc">Price Desc</option>
                    </select>
                  </div>
                  <button
                    onClick={sidebarController}
                    type="button"
                    className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                  >
                    <i className="ph-bold ph-funnel" />
                  </button>
                </div>
              </div>
              {/* Top End */}

              <div className={`list-grid-wrapper ${grid ? "list-view" : ""}`}>
                {products.length > 0 ? (
                  productList
                ) : (
                  <h6 className="text-center p-30">No products available</h6>
                )}
              </div>
              {loading ? (
                <div>
                  <Preloader />
                  {/* <img src="../../assets/images/icon/preloader.gif" alt="" /> */}
                  {/* <i className="ph ph-spinner animate-spin text-2xl d-flex" /> */}
                </div>
              ) : (
                <div></div>
              )}
              {/* Pagination Start */}
              {totalItems > 0 && (
                <ul className="pagination flex-center flex-wrap gap-16">
                  {/* Previous Button */}
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <Link
                      className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                      to="#"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      <i className="ph-bold ph-arrow-left" />
                    </Link>
                  </li>

                  {/* Page Numbers */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                      >
                        <Link
                          className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(page);
                          }}
                        >
                          {page.toString().padStart(2, "0")}
                        </Link>
                      </li>
                    )
                  )}

                  {/* Next Button */}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <Link
                      className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                      to="#"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      <i className="ph-bold ph-arrow-right" />
                    </Link>
                  </li>
                </ul>
              )}
              {/* Pagination End */}
            </div>

            {/* Content End */}
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(ProductListPage);
